export const setTitle = (title) => {
  document.title = `Catalogue Apprentissage - ${title}`;
};
